import { Component, OnInit } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EmpMasterModel } from '../../model'
// import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
import { Router } from "@angular/router"
import * as $ from 'jquery';
import { ColumnGroup } from 'ag-grid-community';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-employeemaster',
    template: require('./employeemaster.component.html'),
    styles: [require('./employeemaster.component.css')],
    viewProviders: [ApiService]
})
// @Injectable({
//   providedIn: 'root',
// })
export class EmployeeMasterComponent implements OnInit {
    EmpData: EmpMasterModel = new EmpMasterModel();
    empDetails: any = [];
    busy: Subscription;
    private columnDefs;
    private rowHeight;
    api: any;
    stateList: any = [];
    headQuarterList: any = [];
    ManagerList: any
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    token:any;

    Emp_Form = new FormGroup({
        stateId: new FormControl('', [Validators.required]),
        hq: new FormControl('', [Validators.required]),
        ManagerID: new FormControl('', [Validators.required]),
        status: new FormControl('', [Validators.required]),

    });

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
        this.apiService = apiService;
        var parent = this;
        this.columnDefs = [
            {
                headerName: 'Status', field: "", width: 100, cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    var eSpan = document.createElement('span');
                    eSpan.id = "Status_" + params.data.EmpId;
                    eSpan.setAttribute('class', 'inActive');
                    if (params.data.Active == 1) {
                        eSpan.setAttribute('style', 'color:green;cursor:pointer');
                        eSpan.innerHTML = "Active";
                    }
                    else {
                        eSpan.setAttribute('style', 'color:red;cursor:pointer');
                        eSpan.innerHTML = "InActive";
                    }
                    //    eSpan.innerHTML = (params.data.Active == 1? `Active`:params.data.Active == 0? `Inactive`:``);
                    eDiv.appendChild(eSpan);
                    var inActive = eDiv.querySelectorAll('.inActive')[0];
                    inActive.addEventListener('click', function () {
                        parent.InActive(params.data);
                    });
                    return eDiv
                }
            },
            //{ headerName: 'Action', field: "Client_Name", suppressSizeToFit: true },
            { headerName: 'Employee Code', field: "Client_Code" },
            { headerName: 'Employee Name', field: "Client_Name" },
            { headerName: 'Manager', field: "Manager" },
            // { headerName: 'Division', field: "DivisionName" },
            { headerName: 'Category', field: "category" },
            { headerName: 'DOJ', field: "DOJ" },
            { headerName: 'Designation', field: "ClientTypeDesc" },
            { headerName: 'Email', field: "Email" },
            { headerName: 'HQ', field: "HQName" },
            { headerName: 'State', field: "StateName" },
            { headerName: 'Last Working Date', field: "Last Working Date" }
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };

    }


    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        this.getState();
        this.getHeadQuarterList();
        this.getManagerDetails();
        this.EmpData.status = -1;
        this.EmpData.stateId = 0;
        this.EmpData.HQ = 0;
        this.EmpData.ManagerID = 0;

    }
    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateList = res.data;
        })
    }

    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog',data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    InActive(event) {
        var tokenData = JSON.parse(sessionStorage.getItem("currentUser"));
        let id = tokenData.id;
        var text = $('#Status_' + event.EmpId).text();
        let status = (text == "InActive" ? 1 : 0);
        let data = { EmpId: event.EmpId, Active: status, id: id };
        this.busy = this.http.post('/api/usermasters/UpdateEmployeeStatus', data).subscribe((res: any) => {
            console.log("response", res);
            if (res.length > 0) {
                if (res[0].flag == 1) {
                    if (status == 0) {
                        $('#Status_' + event.EmpId).text("InActive");
                        $('#Status_' + event.EmpId).css('color', 'red');
                    } else {
                        $('#Status_' + event.EmpId).text("Active");
                        $('#Status_' + event.EmpId).css('color', 'green');

                    }
                } else {
                    alert(res[0].msg)
                }
            }
        })
    }
    empmaster() {
        this.router.navigate(['/addemployeemaster']);
    }


    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'employeemaster' });
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    getEmpDetails() {
        this.EmpData.empId = this.token.id;
        console.log(this.EmpData);

        this.busy = this.apiService.getEmpDetailsByFilter(this.EmpData).subscribe((res: any) => {
            console.log("response", res)
            this.empDetails = res;
            // if (this.empDetails.length > 0) {
            //   let column = Object.keys(this.empDetails[0]);
            //   console.log('columns', column);
            //   // gridOptions.api.setColumnDefs(column);
            //   let dynamicColumnDef: any = [];
            //   column.forEach(data => {
            //     let demo: any = {
            //       headerName: data.toString(),
            //       field: data.toString()
            //     };
            //     dynamicColumnDef.push(demo);

            //   });
            //   this.columnDefs = dynamicColumnDef;
            // }
        })


    }

    /* gridHeight() {
        // var height = 0;
        let windowHeight = window.innerHeight;
        let mainContentHeight = document.querySelector(".main_content").clientHeight;
        let mainContentHeaderHeight = document.querySelector(".main_content_header").clientHeight;
        document.getElementById('gridHeight').style.height = `${mainContentHeight - mainContentHeaderHeight - 60}px`;
        console.log('Window', windowHeight, 'MAIN HEIGHT', mainContentHeight, "HEADER HEIGHT", mainContentHeaderHeight);
    } */
}
